import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api, ApiError, errorText } from '../../api';
import { fehlendeFunktion } from '../../billtoro/upgrade';
import { ausgabenVonLieferant, deDatum, euro, type LieferantAusgaben as Antwort } from '../ausgaben/daten';
import type { Overview } from '../types';
import './kontakte.css';

// so viele Ausgaben zeigt die Karte, die übrigen stehen unter „Alle Ausgaben“
const ZEILEN = 10;

// Karte „Ausgaben“ im Lieferanten-Detail (nur Billtoro): die letzten Ausgaben, die mit diesem Lieferanten verknüpft
// sind, neueste zuerst, stornierte durchgestrichen. Ansehen braucht keinen Tarif: Mit Einträgen steht die Karte immer
// da (auch nach einer Rückstufung), leer nur, wenn der Tarif Ausgaben enthält (keine Werbung für „bald“). Lieferant
// gerade entfernt (404): keine Karte. onAnzahl meldet die Zahl für den Satz im Fenster „entfernen?“.
// Eine einzelne Ausgabe öffnet sich noch nicht von hier (die Ausgabenliste kennt keinen Link auf eine Ausgabe).
export function LieferantAusgaben({ data, lieferantId, onAnzahl }: { data: Overview; lieferantId: string; onAnzahl(n: number): void }) {
  const [res, setRes] = useState<Antwort | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let weg = false;
    setRes(null);
    setError(null);
    onAnzahl(0);
    api.get<Antwort>(ausgabenVonLieferant(data.firm.id, lieferantId)).then(
      (r) => {
        if (weg) return;
        setRes(r);
        onAnzahl(r.ausgaben.length);
      },
      (err) => {
        if (weg || (err instanceof ApiError && err.status === 404)) return;
        setError(errorText(err));
      },
    );
    return () => {
      weg = true;
    };
  }, [data.firm.id, lieferantId, onAnzahl]);

  const n = res?.ausgaben.length ?? 0;
  const imTarif = fehlendeFunktion(data.tarif, 'ausgaben') === null;
  if (!n && !imTarif) return null;
  if (!res && !error) return null;

  return (
    <section className="rt-card kt-karte" aria-labelledby="kt-ausgaben-h">
      <div className="kt-karte-kopf">
        <h2 id="kt-ausgaben-h">Ausgaben</h2>
        {n > 0 && (
          <span className="muted kt-anzahl">
            {res?.mehr ? `mehr als ${n}` : n} {n === 1 && !res?.mehr ? 'Ausgabe' : 'Ausgaben'}
          </span>
        )}
      </div>
      {error ? (
        <div className="notice bad">{error}</div>
      ) : n === 0 ? (
        <p className="muted kt-leer">Noch keine Ausgaben von diesem Lieferanten.</p>
      ) : (
        <ul className="kt-liste">
          {res!.ausgaben.slice(0, ZEILEN).map((a) => (
            <li key={a.id} className={`kt-ausgabe${a.storniert ? ' kt-storniert' : ''}`}>
              <div className="kt-ausgabe-text">
                <b className="num">{a.nummer}</b>
                <span className="muted num">{deDatum(a.belegdatum)}</span>
                <span className="kt-ausgabe-was">{a.text ?? a.partner}</span>
              </div>
              <div className="kt-zeile-act">
                {a.storniert && (
                  <span className="badge b-none" title={a.storniert.grund}>
                    storniert
                  </span>
                )}
                <span className="kt-ausgabe-betrag num">{euro(a.brutto)}</span>
              </div>
            </li>
          ))}
        </ul>
      )}
      <p className="kt-klein">
        {n > ZEILEN && <span className="muted">Die letzten {ZEILEN}. </span>}
        <Link to="/rechnung/steuer">Alle Ausgaben</Link>
      </p>
    </section>
  );
}
